import { FETCH_SECURITIES } from '@ovComponents/3-pattern/securitySelect/queries';
import { usePermission } from '@providers/userContextProvider';
import { useCallback } from 'react';
import {
  buildExposureSearchVariables,
  mapFinancialProductSearchHits,
  TOOLBAR_SEARCH_MIN_CHARS,
} from '../utils/portfolioSearchOptions';
import { useLazySearchOptions } from './useLazySearchOptions';

export function useExposureSearchOptions({
  organizationId,
}: {
  organizationId?: string;
}) {
  const canReadFinancialProducts = usePermission('read:financial_products');

  const buildVariables = useCallback(
    (trimmed: string) =>
      buildExposureSearchVariables(organizationId as string, trimmed),
    [organizationId],
  );

  const mapResults = useCallback(
    (
      data:
        | { fetchFinancialProducts?: { financialProducts?: unknown } }
        | undefined,
    ) =>
      mapFinancialProductSearchHits(
        data?.fetchFinancialProducts?.financialProducts as Parameters<
          typeof mapFinancialProductSearchHits
        >[0],
      ),
    [],
  );

  return useLazySearchOptions({
    query: FETCH_SECURITIES,
    minChars: TOOLBAR_SEARCH_MIN_CHARS,
    isEnabled: Boolean(organizationId && canReadFinancialProducts),
    buildVariables,
    mapResults,
    errorMessageKey: 'filters.exposureSearchFailed',
  });
}
